import { isDevelopingApp, macroCondition, getOwnConfig } from "@embroider/macros";
import { assert } from '@ember/debug';
import { isStableIdentifier } from '../caches/identifier-cache';
let tokenId = 0;
const Cache = new Map();
const Tokens = new Map();
// TODO this isn't importable anyway, remove and use a map on the manager?
export function unsubscribe(token) {
  let identifier = Tokens.get(token);
  if (macroCondition(getOwnConfig().debug.LOG_NOTIFICATIONS)) {
    if (!identifier) {
      // eslint-disable-next-line no-console
      console.log('Passed unknown unsubscribe token to unsubscribe', identifier);
    }
  }
  if (identifier) {
    Tokens.delete(token);
    const map = Cache.get(identifier);
    map?.delete(token);
  }
}
/*
  Currently only support a single callback per identifier
*/
export default class NotificationManager {
  constructor(store) {
    this.store = store;
    this.isDestroyed = false;
  }
  subscribe(identifier, callback) {
    assert(`Expected to receive a stable Identifier to subscribe to`, isStableIdentifier(identifier));
    let map = Cache.get(identifier);
    if (!map) {
      map = new Map();
      Cache.set(identifier, map);
    }
    let unsubToken = macroCondition(isDevelopingApp()) ? {
      _tokenRef: tokenId++
    } : {};
    map.set(unsubToken, callback);
    Tokens.set(unsubToken, identifier);
    return unsubToken;
  }
  unsubscribe(token) {
    if (!this.isDestroyed) {
      unsubscribe(token);
    }
  }

  // deactivated type signature overloads because pass-through was failing to match any. Bring back if possible.
  // notify(identifier: StableRecordIdentifier, value: 'attributes' | 'relationships', key?: string): boolean;
  // notify(identifier: StableRecordIdentifier, value: 'errors' | 'meta' | 'identity' | 'state'): boolean;
  notify(identifier, value, key) {
    assert(`Notify does not accept a key argument for the namespace '${value}'. Received key '${key}'.`, !key || value === 'attributes' || value === 'relationships');
    if (!isStableIdentifier(identifier)) {
      if (macroCondition(getOwnConfig().debug.LOG_NOTIFICATIONS)) {
        // eslint-disable-next-line no-console
        console.log(`Notifying: Expected to receive a stable Identifier to notify '${value}' '${key}' with, but ${String(identifier)} is not in the cache`, identifier);
      }
      return false;
    }
    if (macroCondition(getOwnConfig().debug.LOG_NOTIFICATIONS)) {
      // eslint-disable-next-line no-console
      console.log(`Notifying: ${String(identifier)}\t${value}\t${key}`);
    }
    let callbackMap = Cache.get(identifier);
    if (!callbackMap || !callbackMap.size) {
      return false;
    }
    callbackMap.forEach(cb => {
      cb(identifier, value, key);
    });
    return true;
  }
  destroy() {
    this.isDestroyed = true;
    Tokens.clear();
    Cache.clear();
  }
}